import { useState, useRef, useEffect } from 'react';
import { ChevronDown, Check } from 'lucide-react';

export default function StyledSelect({ options, value, onChange, placeholder = 'Select...' }) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedOption = options.find((o) => o.value === value);

  return (
    <div ref={ref} className="relative">
      {/* Trigger */}
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`flex w-full min-w-[170px] items-center justify-between gap-2 rounded-xl border px-3.5 py-2.5 text-sm transition-all ${
          isOpen
            ? 'border-neon-cyan/50 bg-surface-700 text-slate-100 shadow-neon-cyan'
            : 'border-surface-600 bg-surface-700 text-slate-300 hover:border-neon-cyan/30 hover:text-slate-100'
        }`}
      >
        <span className={selectedOption ? 'text-slate-100' : 'text-slate-500'}>
          {selectedOption ? selectedOption.label : placeholder}
        </span>
        <ChevronDown
          size={15}
          className={`text-neon-cyan transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>

      {/* Dropdown */}
      {isOpen && (
        <div className="absolute z-30 mt-1.5 w-full min-w-[170px] overflow-hidden rounded-xl border border-surface-600 bg-surface-800 shadow-lg shadow-black/40">
          <div className="max-h-56 overflow-y-auto py-1">
            {options.map((option) => {
              const isSelected = option.value === value;
              return (
                <button
                  key={option.value}
                  onClick={() => {
                    onChange(option.value);
                    setIsOpen(false);
                  }}
                  className={`flex w-full items-center justify-between px-3.5 py-2.5 text-left text-sm transition-colors ${
                    isSelected
                      ? 'bg-neon-cyan/10 text-neon-cyan'
                      : 'text-slate-300 hover:bg-surface-700 hover:text-slate-100'
                  }`}
                >
                  <span>{option.label}</span>
                  {isSelected && <Check size={14} className="text-neon-cyan" />}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
